













import Vue from 'vue'
import { oneOf } from '@/utils/helper'
import Button from '@/components/shared/atoms/Button/Button'

export default Vue.extend({
  components: {
    Button
  },
  props: {
    text: {
      type: String,
      default: '前のページに戻る'
    },
    type: {
      type: String,
      default: 'default',
      validator: oneOf(['default', 'button'])
    },
    buttonType: {
      type: String,
      default: 'secondary',
      validator: oneOf(['primary', 'secondary'])
    }
  },
  computed: {
    hasBrowserHistory(): boolean {
      if (process.env.NODE_ENV === 'test') return true

      // Storybook上では常にtrueを返す
      if (typeof document !== 'object') return false
      const title = document.querySelector('title')
      if (!title) return false
      if (title.text === 'Storybook') return true

      if (!process.client) return false
      if (typeof window !== 'object') return false
      if (typeof window.history !== 'object') return false
      return window.history.length > 1
    }
  }
})
